export const CHANGE_CURRENT_SYNC_VIEW = 'CHANGE_CURRENT_SYNC_VIEW'
